import React, { useState } from "react";
import SEO from "../common/SEO";
import HeaderOne from "../common/header/HeaderOne";
import FooterTwo from "../common/footer/FooterTwo";
import { useTranslation } from "react-i18next";
import { FiArrowRight } from "react-icons/fi";
import DemoLine from "../elements/split/chart";
import MapComponent from "../elements/split/map";
import "./BusinessConsulting2.css";

const BusinessConsulting2 = () => {
  const { t } = useTranslation();
  const [activeFAQ, setActiveFAQ] = useState(null);

  const toggleFAQ = (index) => {
    setActiveFAQ(activeFAQ === index ? null : index);
  };

  const faqData = [
    {
      question: t("634"),
      answer: t("635"),
    },
    {
      question: t("636"),
      answer: t("637"),
    },
    {
      question: t("638"),
      answer: t("639"),
    },
    {
      question: t("640"),
      answer: t("641"),
    },
    {
      question: t("642"),
      answer: t("643"),
    },
  ];

  const processSteps = [
    {
      number: "1",
      title: t("623"),
      description: t("624"),
    },
    {
      number: "2",
      title: t("625"),
      description: t("626"),
    },
    {
      number: "3",
      title: t("627"),
      description: t("628"),
    },
    {
      number: "4",
      title: t("629"),
      description: t("630"),
    },
    {
      number: "5",
      title: t("631"),
      description: t("632"),
    },
  ];

  return (
    <>
      <SEO title="Cyberate Investment - Smarter Property Investment Begins with Strategy" />
      <main className="page-wrapper">
        <HeaderOne btnStyle="round" HeaderSTyle="header-not-transparent" />

        {/* Hero Banner */}
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "100vh",
            overflow: "hidden",
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg/home.png)`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            background: "#000",
          }}
        >
          <video
            autoPlay
            loop
            muted
            playsInline
            onError={(e) => {
              console.error("视频加载错误:", e);
            }}
            onLoadedData={() => {
              console.log("视频加载成功");
            }}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: 1,
            }}
          >
            <source
              src={`${process.env.PUBLIC_URL || ''}/images/about/Cyberate_Investment_final.mp4`}
              type="video/mp4"
            />
            您的浏览器不支持视频播放。
          </video>
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              zIndex: 2,
            }}
          ></div>
          <div className="container" style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "white",
            textAlign: "center",
            zIndex: 3,
            width: "100%",
          }}>
            <div className="row">
              <div className="col-lg-12">
                <div className="hero-content text-center">
                  <h1 className="hero-title">
                    {t("600")}<br />
                    {t("601")}<br />
                    {t("601_1")}
                  </h1>
                  <div className="hero-button">
                    <button
                      className="cta-button"
                      onClick={() => {
                        window.location.href = "/FreeConsult";
                      }}
                    >
                      {t("602")} <FiArrowRight />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Strategy Section */}
        <div className="strategy-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="strategy-content text-center">
                  <h2 className="strategy-main-title">{t("603")}</h2>
                  <p className="strategy-text">{t("604")}</p>
                  <p className="strategy-text">{t("605")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Assets and Projects Section */}
        <div className="assets-projects-section">
          <div className="container">
            <div className="row">
              {/* Project Showcase Map */}
              <div className="col-lg-6">
                <div className="projects-content text-center">
                  <h3 className="projects-title">{t("607")}</h3>
                  <p className="projects-link">
                    <a href={process.env.PUBLIC_URL + "/ProjectGallery"} className="gallery-link">
                      {t("608")} <FiArrowRight />
                    </a>
                  </p>
                  <div className="map-wrapper">
                    <MapComponent />
                  </div>
                </div>
              </div>
              
              {/* Assets Under Management Growth */}
              <div className="col-lg-6">
                <div className="assets-content text-center">
                  <h3 className="assets-title">{t("606")}</h3>
                  <p className="assets-description">{t("512")}</p>
                  <div className="chart-wrapper">
                    <DemoLine />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Service Section */}
        <div className="service-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-header text-center">
                  <h2 className="section-title">{t("609")}</h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-8 mx-auto">
                <div className="service-intro text-center">
                  <p>{t("611")}</p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6">
                <div className="service-card advisor-card">
                  <h4 className="service-card-title">{t("617")}</h4>
                  <p className="service-card-text">{t("618")}</p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="service-card investor-card">
                  <h4 className="service-card-title">{t("619")}</h4>
                  <p className="service-card-text">{t("620")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Investment Process Section */}
        <div className="process-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-header text-center">
                  <h2 className="section-title">{t("621")}</h2>
                  <p className="section-subtitle">{t("622")}</p>
                </div>
              </div>
            </div>
            <div className="row">
              {processSteps.map((step, index) => (
                <div key={index} className="col-12 col-sm-6 col-lg-2-4">
                  <div className="process-card">
                    <div className="process-number">
                      <span className="number">{step.number}</span>
                    </div>
                    <h5 className="process-title">{step.title}</h5>
                    <p className="process-description">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="faq-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-header text-center">
                  <h2 className="section-title">{t("633")}</h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="faq-container">
                  {faqData.map((faq, index) => (
                    <div key={index} className="faq-card" onClick={() => toggleFAQ(index)}>
                      <div className="faq-question-content">
                        <h5 className="faq-question-text">Q{index + 1}:{faq.question}</h5>
                        <FiArrowRight 
                          className={`faq-arrow ${activeFAQ === index ? 'faq-arrow-active' : ''}`}
                        />
                      </div>
                      {activeFAQ === index && (
                        <div className="faq-answer in-card">
                          <p className="faq-answer-text">A{index + 1}:{faq.answer}</p>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        {/* <div className="cta-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="cta-content text-center">
                  <h2 className="cta-title">Ready to Start Your Investment Journey?</h2>
                  <button className="cta-button">
                    {t("644")} <FiArrowRight />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <FooterTwo />
      </main>
    </>
  );
};

export default BusinessConsulting2;
